// extracted by mini-css-extract-plugin
export default {"text":"ErrorMessage_text__6a1hK"};